import clsx from 'clsx';

import { MantineTheme, SwitchProps } from '@mantine/core';

import switchClasses from './Switch.module.css';

export const DefaultSwitchProps: Partial<SwitchProps> = {
  size: 'sm'
};

export const SwitchOverrideClassNames = (
  theme: MantineTheme,
  props: SwitchProps
) => {
  return {
    root: switchClasses.root,
    body: switchClasses.body,
    label: switchClasses.label,
    track: clsx(switchClasses.track, {
      [switchClasses.trackXs]: props.size === 'xs',
      [switchClasses.trackSm]: props.size === 'sm',
      [switchClasses.trackMd]: props.size === 'md',
      [switchClasses.trackLg]: props.size === 'lg',
      [switchClasses.trackXl]: props.size === 'xl'
    }),
    thumb: clsx(switchClasses.thumb, {
      [switchClasses.thumbXs]: props.size === 'xs',
      [switchClasses.thumbSm]: props.size === 'sm',
      [switchClasses.thumbMd]: props.size === 'md',
      [switchClasses.thumbLg]: props.size === 'lg',
      [switchClasses.thumbXl]: props.size === 'xl'
    }),
    input: switchClasses.input
  };
};
